export const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const BASE_IMAGE_UPLOAD_URL = import.meta.env.VITE_API_IMAGE_UPLOAD_URL;

export const ADMIN_LOGIN_URL = "admin/login";

export const ADMIN_GMAIL_LOGIN_URL = "admin/login/gmail";

export const SEARCH_PRODUCT_URL = "admin/catalog/search";

export const CATEGORY_BRAND_URL = `${BASE_URL}admin/catalog/getCategoriesWithBrands`;

export const SHOP_INVENTORY_CATEGORY_BRAND_URL = `${BASE_URL}admin/shop/inventory/getCategoriesWithBrands`;

export const CREATE_PRODUCT_URL = `${BASE_URL}admin/catalog/product/create`;

export const UPDATE_PRODUCT_URL = `${BASE_URL}admin/catalog/product/update`;

export const UPLOAD_PRODUCT_IMAGE_URL = `${BASE_URL}admin/catalog/uploadUrl`;

export const GET_PRODUCT_DETAIL_URL = `admin/catalog/product`;

export const GET_ALL_SHOPS = `/admin/shop/getAllShops`;

export const GET_SHOP_PRODUCTS = `/admin/shop/inventory/getProducts/{shopId}`;

export const CREATE_SHOP_PRODUCT_URL = `/admin/shop/inventory/product/create`;

export const UPDATE_SHOP_PRODUCT_URL = `admin/shop/inventory/product/update`;

export const GET_SHOP_PRODUCT_DETAIL_URL = `/admin/shop/inventory/product`;

export const DELETE_SHOP_PRODUCT_URL = `/admin/shop/inventory/product/delete`;

export const UPDATE_SHOP_DETAILS = `/admin/shop/update`;

export const GET_SHOP_DETAILS = `/admin/shop`;

export const GET_SHOP_DRAFT_PRODUCTS = `/admin/shop/inventory/getDraftProducts/{shopId} `;

export const GET_SHOP_DRAFT_PRODUCT_DETAIL_URL = `/admin/shop/inventory/draftProduct`;

export const CREATE_SHOP_DRAFT_PRODUCT_URL = `/admin/shop/inventory/draftProduct/create`;

export const UPDATE_SHOP_DRAFT_PRODUCT_URL = `/admin/shop/inventory/draftProduct/update`;

export const GET_ALL_ORDERS = `/admin/order/getOrders`;

export const GET_ORDER_DETAILS = `/admin/order/ondc`;

export const GENERATE_SETTLEMENTS_URL = `/admin/order/manualSettlement`;

export const GET_ALL_CAT_DOCUMENTS = `/admin/catalog/fetchCatalogData`;

export const GENERATE_CAT_DOCUMENTS = `/admin/catalog/generateCatalog`;

export const MIGRATE_CAT_DOCUMENTS_TO_MASTER_CATALOG = `/admin/catalog/moveToMasterCatalog`;

export const GET_ORDER_STATUS_TIMELINE = `/admin/order/getOrderStatus`;

export const GET_PRODUCT_TAXONOMY = `/admin/config/taxonomy`;

export const GET_PRODUCT_PRODUCTSPEC = `/admin/config/productSpec`;

export const GET_ORDER_CANCEL_AND_RETURN_REASON = `/admin/config/reasonCodes`;

export const UPLOAD_KYC_DOC_IMAGE_URL = `/admin/kyc/getPresignedUrl`;

export const CREATE_SHOP_KYC = `/admin/kyc/create`;

export const BASE_SHOP_IMAGE_UPLOAD_URL = import.meta.env
  .VITE_SHOPIMAGE_API_BASE_URL;

export const UPLOAD_SHOP_IMAGE_URL = `${BASE_URL}admin/shop/image/fetchPresignedUrl`;

export const GET_SHOP_OFFERS = `/admin/fetch/offers/{shopId}`;

export const GET_SINGLE_OFFER_DETAILS = `/admin/fetch/offer`;

export const CREATE_SHOP_OFFERS = `/admin/offer/create`;

export const BASE_SHOP_OFFERIMAGE_UPLOAD_URL = import.meta.env
  .VITE_OFFER_API_BASE_URL;

export const UPLOAD_SHOP_OFFER_IMAGE_URL = `${BASE_URL}admin/offer/getPresignedUrl`;

export const UPDATE_SHOP_OFFERS = `/admin/offer/update`;

export const FETCH_PRODUCTS_WITH_ID = `/admin/shop/inventory/fetchProductsByIds`;

export const FETCH_OFFER_ITEMS_USING_CSV = `/admin/offer/fetchOfferItemsUsingCsv`;

export const GENERATE_ONDC_FA_SETTLEMENTS_URL = `/admin/order/manualOndcFaSettlement`;

export const GET_PRODUCTS_WITH_CATEGORY_BRAND = `admin/catalog/getProducts`;

export const GET_PRODUCTS_WITH_BARCODE = `admin/catalog/fetchProductsUsingBarcodes`;

export const GET_SINGLE_SHOP_OUTGOING_PAYMENTS = `/admin/order/fetchSettlements/{shopId}`;

export const GET_DASHBOARD_CATALOG_DATA = `/admin/catalog/dashboard/fetchCatalogData`;

export const GET_DASHBOARD_SHOP_DATA = `/admin/shop/dashboard/getShopsData`;

export const GET_DASHBOARD_ORDER_DATA = `/admin/order/dashboard/fetchOrders`;

export const GET_SINGLE_SETTLEMENT_DETAILS = `/admin/order/getSettlementDetails`;

export const UPLOAD_CSV_FILE = `/admin/shop/inventory/addProductsUsingCsv/{shopId}`;

export const ORDER_STATUS_UPDATE = `/admin/order/ondc/status`;

export const ORDER_PARTIAL_CANCEL = `/admin/order/ondc/edit`;

export const GET_SHOP_ADMIN_DASHBOARD_ORDER_DATA = `/admin/shop/order/dashboard/fetchOrders`;

export const GET_SHOP_DELIVERY_AGENTS = `/admin/fetch/storeEmployee/{shopId}`;

export const ASSIGN_TO_DELIVERY_AGENT = `/admin/order/assignToDeliveryUser`;

export const REASSIGN_TO_DELIVERY_AGENT = `/admin/order/reassignOrder`;

export const ORDER_MODIFY = `/admin/order/modify`;

export const POS_BILL_SYNC = `/admin/order/pos/billSync`;

export const GET_ALL_SHOP_ITEMS = `/admin/shop/inventory/searchAllShopProductsWithMinValidation/{shopId}`;

export const GET_SHOP_CONFIG = `/admin/shop/config/{id}`;

export const GET_SHOP_CONFIG_DETAILED = `/admin/shop/config/detailed/{id}`;
export const CREATE_SHOP_CONFIG = `/admin/shop/config/create`;
export const UPDATE_SHOP_CONFIG = `/admin/shop/config/update`;

export const GET_SHOP_CUSTOMERS = `/admin/customer/address/fetch`;

export const CREATE_SHOP_CUSTOMER_ADDRESS = `/admin/customer/address`;

export const UPDATE_SHOP_CUSTOMER_ADDRESS = `/admin/customer/address/{id}`;

export const DELETE_SHOP_CUSTOMER_ADDRESS = `/admin/customer/address/{id}`;

export const OFFLINE_INITIATE_ORDER = `/admin/order/init`;

export const OFFLINE_ORDER_CREATE = `/admin/order/create`;

export const INVOICE_IMPORT_ORDER = `/admin/order/fetchOrderByInvoiceNumber`;

export const CREATE_NEW_SHOP_EMPLOYEE = `/admin/addStoreEmployee`;

export const FETCH_STORE_EMPLOYEES = `/admin/fetch/storeEmployee/{shopId}`;

export const UPDATE_STORE_EMPLOYEE = `/admin/updateStoreEmployee`;

export const DELETE_STORE_EMPLOYEE = `/admin/storeEmployee/:userId`;

export const SUBSCRIBE_TO_TOPIC_URL = `/admin/notification/subscribeToTopic`;

export const MODIFY_FROM_BILL = `/admin/order/modifyFromBill`;

export const UPDATE_ADDRESS_IN_ORDER = `/admin/order/customer/address/{id}`;

export const UPDATE_ORDER_PAYMENT_MODE = `/admin/order/updatePaymentStatus`;

export const CATALOG_SEARCH = `admin/catalog/search`;

export const SKU_CORRECTION_URL = `admin/orders/items/sku-correction`;

export const GET_DELIVERY_AGENT_PAYMENT_SUMMARY = `/admin/order/reports/deliveryAgents/paymentSummary`;

export const GET_DELIVERY_AGENT_ITEMS_SUMMARY = `/admin/order/reports/deliveryAgents/itemDeliverySummary`;

export const FETCH_SYNCED_BILLS = `/admin/billing/fetchSyncedBills/{shopId}`;

export const SSE_SUBSCRIBE_URL = `/admin/sse/subscribe`;

export const CUSTOMER_ORDER_SUMMARY_URL = `/admin/shop/customers/order-summary`;

export const CUSTOMER_SUMMARY_URL = `/admin/shop/customer/summary`;

export const CUSTOMER_FREQUENTLY_ORDERED_ITEMS_URL = `/admin/shop/customer/frequently-ordered-items`;

export const CUSTOMER_ADDRESSES_URL = `/admin/customer/addresses`;

export const FETCH_CAT_UP_DATA = `/admin/catUploader/fetchCatalogData`;
export const MOVE_CAT_UP_DATA = `/admin/catUploader/moveData`;

export const GET_AVAILABLE_DELIVERY_SLOTS = `/admin/shop/available-slots/{shopId}`;
export const UPDATE_ORDER_DELIVERY_SLOT = `/admin/shop/delivery-slot/order-slot/{shopId}`;

export const GET_DELIVERY_SLOTS_FOR_DATE = `/admin/shop/delivery-slot/slots/{shopId}`;
export const CLOSE_DELIVERY_SLOT = `/admin/shop/delivery-slot/close/{shopId}`;
export const OPEN_DELIVERY_SLOT = `/admin/shop/delivery-slot/open/{shopId}`;
export const BULK_UPDATE_DELIVERY_SLOTS = `/admin/shop/delivery-slot/bulk/{shopId}`;

export const GET_CATEGORIES_AND_SUBCATEGORIES = `/admin/config/getCategoriesAndSubcategories`;

// Shop Onboarding
export const FIND_OR_CREATE_SHOPKEEPER = `/admin/shopkeeper/findOrCreate`;
export const GENERATE_SHOP_SLUG = `/admin/shop/generateSlug`;
export const CHECK_SHOP_SLUG = `/admin/shop/checkSlug`;
export const SAVE_SHOP_ADDRESS = `/admin/shop/address/save`;
export const UPDATE_SHOP_ADDRESS = `/admin/shop/address/update`;
export const GET_USER_ADDRESSES = `/admin/shop/address/user`;
export const GET_SHOP_ADDRESS = `/admin/shop/address`;
export const DELETE_SHOP_ADDRESS = `/admin/shop/address`;
export const CREATE_SHOP = `/admin/shop/create`;

// Subscription plans (charge-at-will)
export const SUBSCRIPTION_PLANS_URL = `/admin/chargeAtWill/plans`;
export const SUBSCRIPTION_PLAN_URL = `/admin/chargeAtWill/plan`;
export const ARCHIVE_SUBSCRIPTION_PLAN_URL = `/admin/chargeAtWill/plan/{planId}/archive`;
export const SHOP_SUBSCRIPTION_URL = `/admin/chargeAtWill/subscription/{shopId}`;
export const SUBSCRIPTION_INVOICES_URL = `/admin/chargeAtWill/subscription/invoices/{shopId}`;
export const CANCEL_SUBSCRIPTION_URL = `/admin/chargeAtWill/subscription/cancel/{shopId}`;
export const CREATE_SUBSCRIPTION_URL = `/admin/chargeAtWill/subscription/create`;
